import { ErrorMessage, Field, Form, Formik } from "formik";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Header from "../components/Header";
import { stateCityMap } from "../constants/constants";
import { bookDemoService } from "../service/bookDemoService";
import { validationSchema } from "../utils/validations";

const BookADemo = () => {
  const initialValues = {
    fullName: "",
    email: "",
    phone: "",
    state: "",
    city: "",
    companyName: "",
    message: "",
  };
  const navigate = useNavigate();
  const handleSubmit = async (values, { resetForm }) => {
    const res = await bookDemoService(values);
    if (res?.data?.statusCode === 200) {
      toast.success(
        "Thank-you for booking a demo with us!  We will get back to you shortly..."
      );
      navigate("/");
    } else {
      setResStatus("Could not submit form. Please try again..");
    }
  };
  const [selectedState, setSelectedState] = useState("");
  const [resStatus, setResStatus] = useState("");

  return (
    <div className="dark">
      <Header />
      <div className="dark bg-gray-950 min-h-screen flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-2xl bg-gray-900 p-8 rounded-3xl shadow-2xl border border-gray-800">
          <h2 className="text-3xl font-bold text-white mb-8 text-center tracking-wide">
            Book a Demo with Us!
          </h2>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ values, setFieldValue }) => (
              <Form className="space-y-6 text-white">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="fullName">Full Name</label>
                    <Field
                      name="fullName"
                      className="mt-1 block w-full bg-gray-800 border border-gray-700 rounded-lg p-2"
                    />
                    <ErrorMessage
                      name="fullName"
                      component="div"
                      className="text-red-500 text-sm"
                    />
                  </div>
                  <div>
                    <label htmlFor="email">Email</label>
                    <Field
                      name="email"
                      type="email"
                      className="mt-1 block w-full bg-gray-800 border border-gray-700 rounded-lg p-2"
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="text-red-500 text-sm"
                    />
                  </div>
                  <div>
                    <label htmlFor="phone">Phone</label>
                    <Field
                      name="phone"
                      className="mt-1 block w-full bg-gray-800 border border-gray-700 rounded-lg p-2"
                    />
                    <ErrorMessage
                      name="phone"
                      component="div"
                      className="text-red-500 text-sm"
                    />
                  </div>
                  <div>
                    <label htmlFor="companyName">Company Name</label>
                    <Field
                      name="companyName"
                      className="mt-1 block w-full bg-gray-800 border border-gray-700 rounded-lg p-2"
                    />
                    <ErrorMessage
                      name="companyName"
                      component="div"
                      className="text-red-500 text-sm"
                    />
                  </div>
                  {/* State and City in one row */}
                  <div className="col-span-2 grid grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="state">State</label>
                      <Field
                        as="select"
                        name="state"
                        className="mt-1 block w-full bg-gray-800 border border-gray-700 rounded-lg p-2"
                        onChange={(e) => {
                          const selected = e.target.value;
                          setSelectedState(selected);
                          setFieldValue("state", selected);
                          setFieldValue("city", "");
                        }}
                      >
                        <option value="">Select State</option>
                        {Object.keys(stateCityMap).map((state) => (
                          <option key={state} value={state}>
                            {state}
                          </option>
                        ))}
                      </Field>
                      <ErrorMessage
                        name="state"
                        component="div"
                        className="text-red-500 text-sm"
                      />
                    </div>

                    <div>
                      <label htmlFor="city">City</label>
                      <Field
                        as="select"
                        name="city"
                        className="mt-1 block w-full bg-gray-800 border border-gray-700 rounded-lg p-2"
                        disabled={!selectedState}
                      >
                        <option value="">Select City</option>
                        {selectedState &&
                          stateCityMap[selectedState]?.map((city) => (
                            <option key={city} value={city}>
                              {city}
                            </option>
                          ))}
                      </Field>
                      <ErrorMessage
                        name="city"
                        component="div"
                        className="text-red-500 text-sm"
                      />
                    </div>
                  </div>
                </div>

                <div>
                  <label htmlFor="message">Message</label>
                  <Field
                    as="textarea"
                    name="message"
                    rows="4"
                    className="mt-1 block w-full bg-gray-800 border border-gray-700 rounded-lg p-2"
                  />
                  <ErrorMessage
                    name="message"
                    component="div"
                    className="text-red-500 text-sm"
                  />
                </div>

                <div className="text-center">
                  <button
                    type="submit"
                    className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition"
                  >
                    Submit
                  </button>
                  <p
                    className={
                      resStatus?.toLowerCase().includes("thank")
                        ? "text-green-600 pt-3"
                        : "text-red-600 pt-3"
                    }
                  >
                    {resStatus}
                  </p>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>{" "}
    </div>
  );
};

export default BookADemo;
